import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Typography,
} from "@material-ui/core"
import ButtonRounded from "components/Common/ButtonRounded"
import AppContext from "contexts/App"
import { useContext, useState } from "react"
import api from "store/api"

import useStyles from "./styles"

const options = [
  { id: 1, name: "Name", value: "name" },
  { id: 2, name: "Profile Picture", value: "profile_picture" },
  { id: 3, name: "Phone", value: "phone" },
  { id: 4, name: "Email", value: "email" },
  { id: 5, name: "Address", value: "address" },
  { id: 6, name: "City", value: "city" },
  { id: 7, name: "County", value: "county" },
  { id: 8, name: "Resume", value: "resume" },
  { id: 9, name: "LinkedIn", value: "linkedIn" },
  // division of columns
  { id: 10, name: "Cover Letter", value: "cover_letter" },
  { id: 11, name: "Occupation", value: "occupation" },
  { id: 12, name: "Education", value: "education" },
  { id: 13, name: "References", value: "references" },
  { id: 14, name: "Qualifiers", value: "qualifiers" },
  { id: 15, name: "Questions", value: "questions" },
]

const DownloadApplicantProfile = () => {
  const classes = useStyles()

  const [selections, setSelections] = useState(
    options?.map((opt) => ({ id: opt.id, value: opt.value }))
  )

  const { dialogs, closeDialog, openSnackBar } = useContext(AppContext)
  const thisDialog = dialogs?.["downloadApplicantProfile"] || {}
  const { open = false, data = {} } = thisDialog

  const applicationId = data?.applicationId
  const applicationName = data?.name

  const handleClose = () => {
    closeDialog("downloadApplicantProfile")
    setTimeout(() => setSelections(options), 150)
  }

  // Change handler for individual checkboxes
  const handleChange = (event, option) => {
    if (event.target.checked) {
      setSelections([...selections, option])
    } else {
      setSelections(selections.filter((s) => s.value !== event.target.name))
    }
  }

  // SELECT ALL btns function as such - remove all previous selections in the range & add back in whole range
  const handleSelectAll = (e) => {
    const column = parseInt(e.currentTarget.id.split("-")[1])
    // either column 1 or column 2..
    if (column === 1) {
      setSelections([
        ...selections.filter((x) => x.id >= 10),
        ...options.filter((x) => x.id < 10),
      ])
    } else {
      setSelections([
        ...selections.filter((x) => x.id < 10),
        ...options.filter((x) => x.id >= 10),
      ])
    }
  }

  //submission function
  const handleSubmit = () => {
    const data = selections.map((sel) => sel.value).join()
    try {
      window.location.href = `${process.env.REACT_APP_API_ENDPOINT}admin/boards/application/${applicationId}/${applicationName}?fields=${data}`
      handleClose()
    } catch {
      openSnackBar({ message: " Error downloading pdf" })
    }
  }

  return (
    <Dialog open={open} classes={{ paperWidthSm: classes.paper }}>
      <DialogTitle disableTypography>
        <Typography variant="h2" style={{ marginBottom: "10px" }}>
          Download Options
        </Typography>
        <Typography>
          Select fields you would like to include in export
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          flexGrow={1}
        >
          <Box display="flex" flexDirection="column">
            <Typography
              color="primary"
              variant="h6"
              style={{ fontWeight: "500", paddingBottom: "10px" }}
            >
              Person Details
            </Typography>
            {options
              ?.filter((p) => p.id < 10)
              .map((opt, i) => {
                return (
                  <FormControlLabel
                    key={i}
                    control={
                      <Checkbox
                        checked={Boolean(
                          selections?.find((s) => s.value === opt.value)
                        )}
                        onChange={(e) => handleChange(e, opt)}
                        name={opt.value}
                      />
                    }
                    label={opt.name}
                    labelPlacement="end"
                  />
                )
              })}
            <Box height="36px">
              {selections.filter((x) => x.id < 10).length !== 9 && (
                <Button
                  id="selectAll-1"
                  style={{ alignSelf: "flex-start" }}
                  onClick={handleSelectAll}
                >
                  <Typography color="primary" variant="button">
                    Select All
                  </Typography>
                </Button>
              )}
            </Box>
          </Box>
          <Box display="flex" flexDirection="column">
            <Typography
              color="primary"
              variant="h6"
              style={{ fontWeight: "500", paddingBottom: "10px" }}
            >
              Application Details
            </Typography>
            {options
              ?.filter((p) => p.id >= 10)
              .map((opt, i) => {
                return (
                  <FormControlLabel
                    key={i}
                    control={
                      <Checkbox
                        checked={Boolean(
                          selections?.find((s) => s.value === opt.value)
                        )}
                        onChange={(e) => handleChange(e, opt)}
                        name={opt.value}
                      />
                    }
                    label={opt.name}
                    labelPlacement="end"
                    classes={{ labelPlacementStart: classes.checkboxLabel }}
                  />
                )
              })}
            <Box height="36px">
              {selections.filter((x) => x.id >= 10).length !== 6 && (
                <Button
                  id="selectAll-2"
                  style={{ alignSelf: "flex-start" }}
                  onClick={handleSelectAll}
                >
                  <Typography color="primary" variant="button">
                    Select All
                  </Typography>
                </Button>
              )}
            </Box>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions style={{ justifyContent: "center" }}>
        <ButtonRounded color="primary" variant="outlined" onClick={handleClose}>
          Cancel
        </ButtonRounded>
        <ButtonRounded
          color="primary"
          variant="contained"
          onClick={handleSubmit}
        >
          Download PDF
        </ButtonRounded>
      </DialogActions>
    </Dialog>
  )
}

export default DownloadApplicantProfile
